export enum ApiKeyStatus {
  Active,
  Expired,
  Revoked,
}
